<template>
    <span class="text-success" v-if="is_true">{{ translate("Yes") }}</span>
    <span class="text-danger" v-else>{{ translate("No") }}</span>
</template>

<script>
export default {
    props: ["is_true"],
};
</script>
